export enum PrescriptionDeliveryMethod {
  Email = 'Email',
  SMS = 'SMS',
  Paper_Token = 'Paper_Token',
}
